<div class="new-unternehmen-info">
    <p>Für die Beantragung benötigen Sie folgende Unterlagen/ Daten:</p>
    <div class="new-unternehmen-info--section-container">
        <section>
            <p>Als Unternehmen:</p>
            <ul>
                <li>
                    Vollmacht von einer zeichnungsberechtigten Person des/der Fördernehmer*in, Sie können diese
                    <a
                        href="Vollmacht-Formular.pdf"
                        (click)="$event.preventDefault(); handleClick()">
                        Vorlage der VFA
                    </a>
                    nutzen
                </li>
                <li>Handels- oder Vereinsregisterauszug nicht älter als 6 Monate</li>
                <li>Umsatzsteuer-ID</li>
                <li>Sofern Ihr Unternehmen vorsteuerabzugsberechtigt ist: Nachweis der Vorsteuerabzugsberechtigung</li>
            </ul>
        </section>
        <section>
            <p>Als natürliche Person:</p>
            <ul>
                <li>Steueridentifikationsnummer</li>
                <li>Gewerbeschein sofern vorhanden</li>
                <li>Sofern Sie vorsteuerabzugsberechtigt sind: Nachweis der Vorsteuerabzugsberechtigung</li>
            </ul>
        </section>
    </div>
    <p>Wenn Sie Fragen dazu haben, melden Sie sich gerne telefonisch bei der VFA-Hotline +49 (42) 424242-0 oder unter info&#64;virtuelle-foerderungsanstalt.de.</p>
    <p>Bitte beachten Sie, dass die Bearbeitung der Stammdaten bis zu 5 Werktage in Anspruch nehmen kann.</p>
</div>
